package org.example.site_web.components.images


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.shapes.Path
import org.example.site_web.aiPalette
import org.jetbrains.compose.web.css.percent


@Composable
fun WrenchSvg(modifier: Modifier = Modifier, frame: Double) {
    Svg(
        attrs = modifier.toAttrs {
            viewBox(0, 0, 64, 64)
        }
    )
    {
        //val agradient = SvgId("agradient")
        val argradient = SvgId("argradient")

        val offset = 100 - frame.toInt()

//        val strokeW = 4
//
//        Defs() {
//            LinearGradient(
//                id = argradient,
//                Modifier.toAttrs {
//                    attr("gradientTransform", "rotate(90)")
//                }) {
//                Stop((0).percent, aiPalette.mainPalette.primary)
//                Stop((100).percent, aiPalette.mainPalette.darkest)
//            }
//
//            RadialGradient(id = agradient) {
//                Stop((0).percent, aiPalette.mainPalette.primary)
//                //Stop((100-offset.value).percent, aiPalette.mainPalette.primary)
//                Stop((100 - offset).percent, aiPalette.mainPalette.darkest)
//                Stop((100).percent, aiPalette.mainPalette.darkest)
//            }
//
//
//        }
//        Mask(Modifier.toAttrs {
//            id("twmask")
//        }) {
//
//            Path {
//                d("m 45.683565,1.0181802 c -3.421373,0.5940859 -6.34818,2.6546172 -8.69985,6.1246799 -1.194052,1.7605771 -1.799637,3.9941559 -1.799637,6.6383499 0,2.169273 0.412648,4.101087 0.689701,5.153992 -4.573614,4.006382 -31.416562,27.528591 -32.3679133,28.470826 -1.7250529,1.708507 -2.67457323,3.979015 -2.67457323,6.393382 0,4.992144 4.08890953,9.042303 9.12974183,9.042303 2.4376267,0 4.7301157,-0.940414 6.4551687,-2.648921 C 19.312446,57.324324 42.14164,31.553403 45.368246,27.908365 L 57.22037,26.841287 55.70353,24.671045 c 2.428085,-1.102195 3.98319,-2.950687 4.955573,-4.638366 1.683126,-2.920422 1.960062,-5.913734 1.971552,-6.039555 l 0.200637,-2.297866 -9.185251,4.548398 -3.834032,-9.69e-4 -1.885585,-2.699054 0.24832,-2.208992 9.899657,-6.5362724 -1.505341,-1.091665 C 56.360711,3.5554624 51.412723,0.02291549 45.683565,1.0181802 Z M 51.619106,18.82646 c 3.003193,0.401731 0,0 0,0 z")
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Path {
//                d("m 12.856468,50.631978 c -0.76307,-0.75588 -1.77679,-1.17188 -2.85551,-1.17188 -1.0787195,0 -2.0943295,0.416 -2.8555095,1.17188 -0.76319,0.75587 -1.18322,1.75975 -1.18322,2.82812 0,1.06838 0.42003,2.07425 1.18322,2.82813 1.57372,1.56049 4.1372995,1.56049 5.7110195,0 0.76319,-0.75388 1.18322,-1.75975 1.18322,-2.82813 0,-1.06837 -0.42003,-2.07225 -1.18322,-2.82812 z"
//                )
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//
//        }

        Rect() {
            x(0)
            y(0)
            width(64)
            height(64)
            fill(argradient)
            attr("mask", "url(#wrench-mask)")
        }
    }
}

